"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
/**
 * Created by Hayk.Andriasyan on 5/10/2018.
 */
var TreeUtils = /** @class */ (function () {
    function TreeUtils() {
    }
    /**
     * Calculates provided element leafs count
     * @param root           provided element
     * @returns {number}   returned count of leads
     */
    TreeUtils.getTreeLeafsCount = function (root) {
        var stack = [];
        stack.push(root);
        var leafsCount = 0;
        var children = [];
        while (stack.length > 0) {
            var head = stack.pop();
            if (head.children && head.children.length > 0) {
                children.push(head.children);
                stack.push(children);
                children = [];
            }
            else {
                leafsCount++;
            }
        }
        return leafsCount;
    };
    TreeUtils.getColumnTreeLeafsCount = function (root) {
        var children = root.children;
        if (children.length === 0) {
            return 1;
        }
        var childCount = 0;
        for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
            var child = children_1[_i];
            childCount += this.getColumnTreeLeafsCount(child);
        }
        return childCount;
    };
    TreeUtils.getMeasurePathTypesByBranchIndex = function (columnRootDto, categoryAndMeasurePaths, categoryExpressionPaths) {
        var branchIndex = 0;
        var branchIndexTypes = new Map();
        (function measureTypesGetter(columnElements, measurePathType) {
            for (var _i = 0, columnElements_1 = columnElements; _i < columnElements_1.length; _i++) {
                var element = columnElements_1[_i];
                if (element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
                    if (element.children.length > 0) {
                        // if measure has children, they can be only categories, so set their measure type to parent measure
                        measureTypesGetter(element.children, TreeUtils.getMeasurePathTypeByPathId(element.measurePathHolderId, categoryAndMeasurePaths));
                    }
                    else {
                        branchIndexTypes.set(branchIndex, TreeUtils.getMeasurePathTypeByPathId(element.measurePathHolderId, categoryAndMeasurePaths));
                        branchIndex += TreeUtils.getTreeLeafs(element);
                    }
                }
                else {
                    if (element.children.length > 0) {
                        measureTypesGetter(element.children, measurePathType);
                    }
                    else {
                        // case if branch does not contain measure category element
                        var categoryPathDto = categoryAndMeasurePaths.categoryPaths.get(element.categoryElementDto.categoryPathHolderId);
                        var nameMeasurePathId = categoryExpressionPaths.has(categoryPathDto.id) ?
                            categoryExpressionPaths.get(categoryPathDto.id).defaultNameMeasurePathId : categoryPathDto.defaultNameMeasurePathId;
                        // if parent is measure, so measurePathType is present, set category measure type to parent measure type
                        branchIndexTypes.set(branchIndex, measurePathType !== undefined ? measurePathType : TreeUtils.getMeasurePathTypeByPathId(nameMeasurePathId, categoryAndMeasurePaths));
                        branchIndex += TreeUtils.getTreeLeafs(element);
                    }
                }
            }
        })(columnRootDto.children);
        return branchIndexTypes;
    };
    TreeUtils.getMeasureByBranchIndex = function (columnRootDto) {
        var branchIndex = 0;
        var branchIndexMeasures = new Map();
        (function measureTypesGetter(columnElements) {
            for (var _i = 0, columnElements_2 = columnElements; _i < columnElements_2.length; _i++) {
                var element = columnElements_2[_i];
                if (element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
                    branchIndexMeasures.set(branchIndex, element);
                    branchIndex += TreeUtils.getTreeLeafs(element);
                }
                else {
                    if (element.children.length > 0) {
                        measureTypesGetter(element.children);
                    }
                    else {
                        // case if branch does not contain measure category element
                        branchIndexMeasures.set(branchIndex, element);
                        branchIndex += TreeUtils.getTreeLeafs(element);
                    }
                }
            }
        })(columnRootDto.children);
        return branchIndexMeasures;
    };
    /**
     * Calculates provided element leafs count
     * @param root           provided element
     * @returns {number}   returned count of leads
     */
    TreeUtils.getTreeLeafs = function (root) {
        return TreeUtils.getColumnTreeLeafsCount(root);
    };
    /**
     * Returns category type, by category id.
     * @param categoryId
     * @returns {CategoryType}
     */
    TreeUtils.getCategoryTypeByCategoryId = function (categoryId, categoryAndMeasurePaths) {
        return categoryAndMeasurePaths.categoryPaths.get(categoryId).categoryType;
    };
    /**
     * Returns measurepath type by path id.
     * @param pathId
     * @returns {MeasurePathType}
     */
    TreeUtils.getMeasurePathTypeByPathId = function (pathId, categoryAndMeasurePaths) {
        return categoryAndMeasurePaths.measurePaths.get(pathId).measurePathType;
    };
    return TreeUtils;
}());
exports.TreeUtils = TreeUtils;
//# sourceMappingURL=tree-utils.js.map